import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/compound-frequency-impact',
  component: () => import('../../routes/CompoundFrequencyImpactCalculator.svelte'),
  card: {
    id: 'compound-frequency-impact',
    title: 'Compound Frequency Impact',
    description: 'Compare how different compounding frequencies (daily, monthly, quarterly, annual) affect your investment returns with the same nominal rate.',
    icon: 'show_chart',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/compound-frequency-impact',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Compound Frequency Impact Calculator – Daily vs Monthly vs Annual Compounding',
    description:
      'Compare investment growth across daily, monthly, quarterly, and annual compounding. See exactly how compounding frequency affects your returns with the same nominal rate.',
  },
};

export default meta;
